import { memo, useEffect, useState } from "react";
import { SPARK_CONFIG } from "./constants/sparkConfig";

const HEX_WIDTH = 256;
const HEX_HEIGHT = 261;

export interface SingleSparkProps {
  onAnimationEnd: () => void;
  worldScale: number;
}

export type SparkPosition = { x: number; y: number };

export const SingleSpark = memo<SingleSparkProps>(({ onAnimationEnd, worldScale }) => {
  const sparkSize = SPARK_CONFIG.SIZE_MULTIPLIER * worldScale;
  
  const [position] = useState<SparkPosition>(() => {
    const centerX = (HEX_WIDTH * worldScale) / 2;
    const centerY = (HEX_HEIGHT * worldScale) / 2;
    const rangeX = (HEX_WIDTH * worldScale) * SPARK_CONFIG.POSITION_RANGE;
    const rangeY = (HEX_HEIGHT * worldScale) * SPARK_CONFIG.POSITION_RANGE;
    
    return {
      x: centerX + (Math.random() - 0.5) * 2 * rangeX,
      y: centerY + (Math.random() - 0.5) * 2 * rangeY
    };
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      onAnimationEnd();
    }, SPARK_CONFIG.ANIMATION_DURATION);
    
    return () => clearTimeout(timer);
  }, [onAnimationEnd]);

  return (
    <div
      className="absolute rounded-full pointer-events-none"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        width: `${sparkSize}px`,
        height: `${sparkSize}px`,
        backgroundColor: '#FFFFFF',
        boxShadow: `
          0 0 ${sparkSize * 0.5}px #FFFFFF,
          0 0 ${sparkSize}px #FFFFFF,
          0 0 ${sparkSize * 1.5}px #FFFFFF80
        `,
        filter: `blur(${SPARK_CONFIG.BLUR_SIZE}px)`,
        animation: `sparkFlyUp ${SPARK_CONFIG.ANIMATION_DURATION}ms ease-out forwards`,
        WebkitAnimation: `sparkFlyUp ${SPARK_CONFIG.ANIMATION_DURATION}ms ease-out forwards`,
        willChange: 'transform, opacity',
        transform: 'translate3d(0, 0, 0)',
        WebkitTransform: 'translate3d(0, 0, 0)',
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
        perspective: 1000,
        WebkitPerspective: 1000,
      }}
    />
  );
});